import { useCallback, useState } from 'react'

export function useModal(initialState = false) {
  const [opened, setOpened] = useState(initialState)
  const toggleModal = useCallback(() => setOpened((prevState: boolean) => !prevState), [])

  return { opened, toggleModal }
}
